import { render, staticRenderFns } from "./ResultLayout.vue?vue&type=template&id=76db2f95&scoped=true&"
import script from "./ResultLayout.vue?vue&type=script&lang=js&"
export * from "./ResultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76db2f95",
  null
  
)

export default component.exports